import React, { useState, forwardRef, useImperativeHandle } from 'react';
import RadioButton from '../RadioButton';
import * as S from './styled';

const ContacDataFooter = ({ contactWay }, ref) => {
  const [informationType, setInformationType] = useState(contactWay);
  const [invalid, setInvalid] = useState(false);
  useImperativeHandle(ref, () => ({
    validate: () => {
      if (informationType?.celular || informationType?.email) {
        return { invalid: false, value: informationType };
      }
      setInvalid(true);
      return { invalid: true, value: informationType };
    },
  }));

  return (
    <S.StyledSectionFooter>
      <S.Text>Como deseja receber informações do Cap Ganhador?</S.Text>
      <S.RadioButtonsWrapper>
        <RadioButton
          text="Celular"
          dark
          bold
          checked={informationType?.celular}
          onChange={() => {
            setInformationType({
              ...informationType,
              celular: !informationType?.celular,
            });
            setInvalid(false);
          }}
          icon="check-p"
          alignLeft
          invalid={invalid}
        />
        <RadioButton
          text="Email"
          dark
          bold
          checked={informationType?.email}
          onChange={() => {
            setInformationType({
              ...informationType,
              email: !informationType?.email,
            });
            setInvalid(false);
          }}
          icon="check-p"
          alignLeft
          invalid={invalid}
        />
      </S.RadioButtonsWrapper>
    </S.StyledSectionFooter>
  );
};

export default forwardRef(ContacDataFooter);
